import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Accordion, Row, Col } from "react-bootstrap";
import faqBanner from "../../Images/student-services/faq-banner.webp";
import { Link } from "react-router-dom";

const FAQPage = () => {
  return (
    <>
      <title>FAQs About ISBM University – Courses, Fees & Admissions</title>
      <meta
        name="description"
        content="Have questions about ISBM University? Explore FAQs on admissions, courses, fees, campus, placements, and more — all answers you’re looking for."
      />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "I want Transfer Certificate how can I process?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can get Transfer Certificate by applying in the prescribed form. The form is available on the University website. Attach a self-attested copy of your mark sheet and pay the prescribed fees."
              }
            },
            {
              "@type": "Question",
              "name": "I want Character Certificate how can I process?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can get Character Certificate by applying in the prescribed form. The form is available on the University website. Attach a self-attested copy of your mark sheet and pay the prescribed fees."
              }
            },
            {
              "@type": "Question",
              "name": "I want Migration Certificate, how can I process?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can get Migration Certificate by applying in the prescribed form. The form is available on the University website. Attach a self-attested copy of your mark sheets and pay the prescribed fees."
              }
            },
            {
              "@type": "Question",
              "name": "Can I apply Transfer Certificate, Character Certificate and Migration Certificate in any one form or there is separate form for it?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, for issue of Transfer Certificate, Character Certificate and Migration Certificate a student can apply in a single form. The form is available on the University website."
              }
            },
            {
              "@type": "Question",
              "name": "What will be the fee payable for Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Fee payable for Transfer Certificate and Character Certificate is Rs. 1000/- each, and for Migration Certificate it is Rs. 1000/-. Transfer Certificate, Character Certificate and Migration Certificate fee will be Rs. 2000/- in combination."
              }
            },
            {
              "@type": "Question",
              "name": "What will be the time line to get Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "One month from the date of application in normal condition. It can differ as per situation."
              }
            },
            {
              "@type": "Question",
              "name": "Can I apply for Transfer Certificate, Character Certificate and Migration Certificate through online?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No, applicant can apply in person. Hard copy application will only be accepted."
              }
            },
            {
              "@type": "Question",
              "name": "Can I send the Demand draft for Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, fees can be paid in the shape of Demand Draft. Demand Draft may be drawn in favour of ISBM University payable at Chhura, Gariyaband."
              }
            },
            {
              "@type": "Question",
              "name": "Are self-attested documents also required?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, self-attested mark sheets/documents must be attached with the application."
              }
            },
            {
              "@type": "Question",
              "name": "What is the process of verification of Certificates/Mark sheets and Degree?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Apply in the prescribed form available on the University website, fill in the form, and send it via registered post to the address of the University. No other mode will be entertained. Attach self-attested mark sheets/documents by paying prescribed fees."
              }
            },
            {
              "@type": "Question",
              "name": "Can I apply Transfer Certificate, Character Certificate and Migration Certificate in another or in my own format?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No, the candidate has to apply in the prescribed format available on the University website only."
              }
            },
            {
              "@type": "Question",
              "name": "To whom I should contact for Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Postal query will only be attended. No other mode will be entertained."
              }
            },
            {
              "@type": "Question",
              "name": "Can I send mail/SMS/WhatsApp or any other social media platform to request for Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No, the candidate has to apply for Transfer Certificate, Character Certificate and Migration Certificate in person or via registered post."
              }
            },
            {
              "@type": "Question",
              "name": "Can any other person apply for Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Only the candidate can apply for himself/herself in person."
              }
            },
            {
              "@type": "Question",
              "name": "Is it possible to collect Transfer Certificate, Character Certificate and Migration Certificate in person?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, the applicant can collect the Transfer Certificate, Character Certificate and Migration Certificate in person after getting information from the University."
              }
            },
            {
              "@type": "Question",
              "name": "In person application is accepted or not for Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, it is accepted."
              }
            },
            {
              "@type": "Question",
              "name": "Do I have to visit the campus to collect Transfer Certificate, Character Certificate and Migration Certificate?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The applicant can collect Transfer Certificate, Character Certificate and Migration Certificate in person or provide a self-addressed stamped envelope to send it by registered post."
              }
            }
          ]
        })}
      </script>
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Frequently Asked Questions</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  FAQs
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="faq-section">
                <Accordion defaultActiveKey="0" flush>
                  {/* Q1 */}
                  <Accordion.Item eventKey="0" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.1</span> I want
                      Transfer Certificate how can I process.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans.-</strong> Yes,
                      </p>
                      <ul className="faq-list">
                        <li>
                          You can get Transfer Certificate by applying in the
                          prescribed form. The form is available in the
                          University website.
                        </li>
                        <li>Attach self-attested copy of your mark sheet.</li>
                        <li>Prescribed fees</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q2 */}
                  <Accordion.Item eventKey="1" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.2</span> I want
                      Character Certificate haw can I process.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> Yes,
                      </p>
                      <ul className="faq-list">
                        <li>
                          You can get Transfer Certificate by applying in the
                          prescribed form. The form is available in the
                          University website.
                        </li>
                        <li>Attach self-attested copy of your mark sheet.</li>
                        <li>Prescribed fees</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q3 */}
                  <Accordion.Item eventKey="2" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.3</span> I want
                      Migration Certificate, how can I process.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> Yes,
                      </p>
                      <ul className="faq-list">
                        <li>
                          You can get Migration Certificate by applying in the
                          prescribed form. The form is available in the
                          University website.
                        </li>
                        <li>Attach self attested copy of your mark sheets.</li>
                        <li>Prescribed fees</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q4 */}
                  <Accordion.Item eventKey="3" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.4</span> Can I apply
                      Transfer Certificate, Character Certificate and Migration
                      Certificate in any one form or there is separate form for
                      it.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> Yes, for issue of transfer
                        certificate, Character certificate and Migration
                        Certificate a student can apply in a single form, the
                        form is available in the University website.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q5 */}
                  <Accordion.Item eventKey="4" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.5</span> What will be
                      the fee payable for Transfer Certificate, Character
                      Certificate and Migration Certificate.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> Fee payable for Transfer
                        Certificate and Character Certificate is Rs 1000/-, and
                        for Migration Certificate it is Rs 1000/-. Transfer
                        Certificate, Character Certificate and Migration
                        Certificate fee will be Rs 2000/- (in combination).
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q6 */}
                  <Accordion.Item eventKey="5" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.6</span> What will be
                      the time line to get Transfer Certificate, Character
                      Certificate and Migration Certificate (How much time it
                      will take to get the Transfer Certificate, Character
                      Certificate and Migration Certificate).
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> One month from the date of
                        application in normal condition. It can differ as per
                        situation.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q7 */}
                  <Accordion.Item eventKey="6" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.7</span> Can I apply
                      for Transfer Certificate, Character Certificate and
                      Migration Certificate through online?
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> No, applicant can apply in
                        person. Hard copy application will only be accepted.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q8 */}
                  <Accordion.Item eventKey="7" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.8</span> Can I send
                      the Demand draft for Transfer Certificate, Character
                      Certificate and Migration Certificate.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> Yes, fees can be paid in the
                        shape of Demand draft. Demand draft may be drawn in
                        favour of ISBM University payabla at Chhura,Gariyaband.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q9 */}
                  <Accordion.Item eventKey="8" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.9</span> Are
                      self-attested documents also required?
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans.</strong> Yes, Self attested mark
                        sheets/documents must be attached with the application.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q10 */}
                  <Accordion.Item eventKey="9" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.10</span> What is the
                      process of verification of Certificates/Mark sheets and
                      Degree.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans.-</strong> Apply in the prescribed form
                        available in University website, fill in the form, send
                        it via registered post in the address of the University.
                        No other mode will be entertained. Attach self attested
                        mark sheets/documents by paying prescribed fees.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q11 */}
                  <Accordion.Item eventKey="10" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.11</span> Can I apply
                      Transfer Certificate, Character Certificate and Migration
                      Certificate in another or in my own format.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> No, the candidate has to apply
                        in the prescribed format available in the University
                        website only.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q12 */}
                  <Accordion.Item eventKey="11" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.12</span> To whom I
                      should contact for Transfer Certificate, Character
                      Certificate and Migration Certificate.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. -</strong> Postal query will only be
                        attended. No other mode will be entertained.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q13 */}
                  <Accordion.Item eventKey="12" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.13</span> Can I send
                      mail/SMS/WhatsApp or any other social media platform to
                      request for Transfer Certificate, Character Certificate
                      and Migration Certificate.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans.-</strong> No, the candidate has to apply
                        for Transfer Certificate, Character Certificate and
                        Migration Certificate in person or via Registered post.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q14 */}
                  <Accordion.Item eventKey="13" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.14</span> Can any
                      other person apply for Transfer Certificate, Character
                      Certificate and Migration Certificate
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. –</strong> Only candidate can apply for
                        himself/ herself in person.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q15 */}
                  <Accordion.Item eventKey="14" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.15</span> Is it
                      possible to collect Transfer Certificate, Character
                      Certificate and Migration Certificate in person.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans.-</strong> Yes, applicant can collect the
                        Transfer Certificate, Character Certificate and
                        Migration Certificate in person after getting
                        information from the University.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q16 */}
                  <Accordion.Item eventKey="15" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.16</span> In person
                      application is accepted or not for Transfer Certificate,
                      Character Certificate and Migration Certificate.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans. –</strong> Yes, It is accepted.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* Q17 */}
                  <Accordion.Item eventKey="16" className="mb-3 shadow-sm">
                    <Accordion.Header>
                      <span className="faq-number me-2">Q.17</span> Do I have to
                      visit the campus to collect Transfer Certificate,
                      Character Certificate and Migration Certificate.
                    </Accordion.Header>
                    <Accordion.Body className="bg-light">
                      <p>
                        <strong>Ans.-</strong> The applicant can collect
                        Transfer Certificate, Character Certificate and
                        Migration Certificate in person or provide self
                        addressed stamped envelope to send it by registered
                        post.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default FAQPage;
